import React, { useState } from 'react';
import { Star } from 'lucide-react';

const StarRating = ({ rating, size = 16, interactive = false, onRatingChange, allowHalf = false }) => {
  const [hoveredRating, setHoveredRating] = useState(0);

  const handleStarClick = (starIndex, isHalf = false) => {
    if (!interactive || !onRatingChange) return;
    const newRating = allowHalf && isHalf ? starIndex - 0.5 : starIndex;
    onRatingChange(newRating);
  };

  const handleStarHover = (starIndex, isHalf = false) => {
    if (!interactive) return;
    const newRating = allowHalf && isHalf ? starIndex - 0.5 : starIndex;
    setHoveredRating(newRating);
  };

  const getStarDisplay = (starIndex) => {
    const currentRating = hoveredRating || rating;
    const isFullStar = starIndex <= currentRating;
    const isHalfStar = allowHalf && starIndex - 0.5 <= currentRating && starIndex > currentRating;
    
    return { isFullStar, isHalfStar };
  };

  return (
    <div className="flex gap-1">
      {[1, 2, 3, 4, 5].map((star) => {
        const { isFullStar, isHalfStar } = getStarDisplay(star);
        
        return (
          <div key={star} className="relative" style={{ width: size, height: size }}>
            {/* Base star (empty) */}
            <Star
              size={size}
              className="text-gray-300 dark:text-gray-600 absolute top-0 left-0"
            />
            
            {/* Half star */}
            {isHalfStar && (
              <div className="absolute top-0 left-0 overflow-hidden" style={{ width: size / 2 }}>
                <Star
                  size={size}
                  className="text-yellow-400 fill-yellow-400"
                />
              </div>
            )}
            
            {/* Full star */}
            {isFullStar && (
              <Star
                size={size}
                className="text-yellow-400 fill-yellow-400 absolute top-0 left-0"
              />
            )}
            
            {/* Interactive overlay */}
            {interactive && (
              <>
                {allowHalf ? (
                  <>
                    {/* Left half for half star */}
                    <div
                      className="absolute top-0 left-0 cursor-pointer hover:scale-110 transition-transform z-10"
                      style={{ width: size / 2, height: size }}
                      onClick={() => handleStarClick(star, true)}
                      onMouseEnter={() => handleStarHover(star, true)}
                      onMouseLeave={() => setHoveredRating(0)}
                    />
                    {/* Right half for full star */}
                    <div
                      className="absolute top-0 cursor-pointer hover:scale-110 transition-transform z-10"
                      style={{ left: size / 2, width: size / 2, height: size }}
                      onClick={() => handleStarClick(star, false)}
                      onMouseEnter={() => handleStarHover(star, false)}
                      onMouseLeave={() => setHoveredRating(0)}
                    />
                  </>
                ) : (
                  <div
                    className="absolute top-0 left-0 cursor-pointer hover:scale-110 transition-transform z-10"
                    style={{ width: size, height: size }}
                    onClick={() => handleStarClick(star)}
                    onMouseEnter={() => handleStarHover(star)}
                    onMouseLeave={() => setHoveredRating(0)}
                  />
                )}
              </>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default StarRating;
